module.exports = __webpack_public_path__ + "media/recipes/26-18d9ac28.png";